package com.macrofocus.eflux.ui.data.risk


val LightningHitBit = 1
val LightningActivityBit = 2
val LightningExpectedBit = 4
val FloodingBit = 16
val MudslideBit = 32
val WindGustsBit = 256
val TemperatureBit = 512